import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const endPoint = 'HousingStock/client';

export const useClientByPhoneQuery = (phone) =>
  useQuery(
    [endPoint, phone],
    () =>
      request.get(endPoint, { phone }, undefined, 'Error', undefined, undefined, undefined, true),
    { enabled: Boolean(phone), staleTime: 0 }
  );
